import * as a from '../actions'

const initialState = {
  user_feedback: {
    open: false,
    message: '',
    action: '',
    autoHideDuration: 1500,
  },
}

const updateLayout = (state = initialState, { type, payload }) => {
  switch (type) {
    case a.APP_FEEDBACK:
      return { ...state, user_feedback: { ...initialState.user_feedback, ...payload } }
    default:
      return state
  }
}

export default updateLayout




// WEBPACK FOOTER //
// ./src/reducers/ui.jsx